import { getClosestConfigurationFromSeat } from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/getClosestConfiguration';
import { SEAT_PURCHASE_STATUS_PURCHASED } from '%paysera_seat_selection/js/seatSelection/config/constants';
import { SEATING_FILL_COLOR_PURCHASED } from '%paysera_seat_selection_integration/js/seatings/Page/config/constants';

function resolveSeatColors(seat) {
    const { seatConfig } = getClosestConfigurationFromSeat(seat, 'seatConfig');
    let colors = {};

    if (seat.purchaseStatus === SEAT_PURCHASE_STATUS_PURCHASED) {
        colors = {
            fill: SEATING_FILL_COLOR_PURCHASED,
            stroke: seatConfig.stroke,
            strokeWidth: seatConfig.strokeWidth,
        };

        return colors;
    }

    if (seat.selected) {
        colors = {
            fill: seatConfig.fill,
            stroke: seatConfig.stroke,
            strokeWidth: seatConfig.strokeWidth,
            ...seatConfig.selected,
        };
        if (!seat.enabled) {
            colors = {
                ...colors,
                fill: seatConfig.disabled.fill,
            };
        }
        if (seat.ticketType !== null) {
            colors = {
                ...colors,
                fill: seat.ticketType.color,
            };
        }
        if (seat.reservation !== null) {
            colors = {
                ...colors,
                fill: seat.reservation.color,
            };
        }
    } else {
        colors = {
            fill: seatConfig.fill,
            stroke: seatConfig.stroke,
            strokeWidth: seatConfig.strokeWidth,
        };
        if (!seat.enabled) {
            colors = {
                ...colors,
                fill: seatConfig.disabled.fill,
                stroke: seatConfig.disabled.stroke,
            };
        }
        if (seat.ticketType !== null) {
            colors = {
                ...colors,
                fill: seat.ticketType.color,
            };
        }
        if (seat.reservation !== null) {
            colors = {
                ...colors,
                fill: seat.reservation.color,
            };
        }
    }

    return colors;
}

export default resolveSeatColors;
